import React, { useState } from "react";
import { Box, BoxProps, Icon, Image } from "@chakra-ui/react";
import { VideoPlayer } from "./VideoPlayer";
import { FaPlay } from "react-icons/fa";

interface VideoContainerProps extends BoxProps {
  url: string;
  thumbnailUrl?: string;
  autoPlay?: boolean;
}

export const VideoContainer: React.FC<VideoContainerProps> = ({
  url,
  thumbnailUrl,
  autoPlay,
  ...boxProps
}) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <Box
      position="relative"
      height="fit-content"
      aspectRatio={16 / 9}
      overflow="hidden"
      borderRadius="6px"
      cursor={!isPlaying && thumbnailUrl ? "pointer" : "default"}
      onClick={() => {
        if (!isPlaying && thumbnailUrl) setIsPlaying(true);
      }}
      {...boxProps}
    >
      {!isPlaying && thumbnailUrl ? (
        <>
          <Image
            src={thumbnailUrl}
            alt="Video thumbnail"
            objectFit="cover"
            w="100%"
            h="100%"
          />
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            bg="rgba(0, 0, 0, 0.5)"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxSize="64px"
          >
            <Icon as={FaPlay} color="white" boxSize="24px" />
          </Box>
        </>
      ) : (
        <VideoPlayer url={url} autoPlay={autoPlay} />
      )}
    </Box>
  );
};
